import { render } from "./HeaderSection.vue?vue&type=template&id=714ace9c&scoped=true"
const script = {}

import "./HeaderSection.vue?vue&type=style&index=0&id=714ace9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714ace9c"]])

export default __exports__